import {HierarchyLookupModel} from '../models/core/HierarchyLookupModel';

export class FilterUtil {
	public static getDeviceModelsBySuplierId(deviceModels: HierarchyLookupModel[], supplierId: number): HierarchyLookupModel[] {
		return  deviceModels == null ? [] : deviceModels.filter(x => x.parentId === supplierId);
	}
}
